// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
    :host {
      font-family: 'DM Sans', 'Segoe UI', sans-serif;
    }

    /* ── Backdrop (mobile only) ── */
    .sidebar-backdrop {
      position: fixed;
      inset: 0;
      background: rgba(60, 0, 100, 0.18);
      -webkit-backdrop-filter: blur(3px);
              backdrop-filter: blur(3px);
      z-index: 1029;
      animation: fadeIn 0.2s ease;
    }

    @keyframes fadeIn {
      from { opacity: 0; }
      to   { opacity: 1; }
    }

    /* ── Sidebar shell ── */
    .sidebar {
      display: flex;
      flex-direction: column;
      width: 240px;
      height: 100%;
      background: #ffffff;
      border-right: 1.5px solid #f0eafa;
      box-shadow: 2px 0 16px rgba(109, 40, 217, 0.06);
      overflow: hidden;
      position: relative;
      z-index: 1030;
      flex-shrink: 0;
    }

    /* ── Mobile ── */
    .sidebar--mobile {
      position: fixed;
      top: 0;
      left: 0;
      height: 100vh;
      width: 260px;
      transform: translateX(-100%);
      transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      z-index: 1030;
    }

    .sidebar--mobile-open {
      transform: translateX(0);
      box-shadow: 6px 0 32px rgba(109, 40, 217, 0.12);
    }

    /* ── Top section ── */
    .sidebar-top {
      display: flex;
      align-items: center;
      padding: 1.125rem 1rem;
      min-height: 64px;
      flex-shrink: 0;
    }

    .sidebar-logo {
      display: flex;
      align-items: center;
    }

    .sidebar-logo-img {
      width: 120px;
      height: auto;
      object-fit: contain;
      display: block;
    }

    /* ── Divider ── */
    .sidebar-divider {
      height: 1px;
      background: linear-gradient(90deg, transparent, #f0eafa 30%, #f9d5ea 70%, transparent);
      flex-shrink: 0;
      margin: 0 0.875rem;
    }

    /* ── Menu area ── */
    .sidebar-menu-wrap {
      flex: 1;
      overflow-y: auto;
      overflow-x: hidden;
      padding: 0.625rem 0;
      scrollbar-width: none;
    }

    .sidebar-menu-wrap::-webkit-scrollbar {
      display: none;
    }

    /* ── Bottom / logout ── */
    .sidebar-bottom {
      flex-shrink: 0;
      padding-bottom: 0.75rem;
    }

    .logout-btn {
      display: flex;
      align-items: center;
      gap: 0.75rem;
      width: 100%;
      padding: 0.65rem 1rem;
      margin-top: 0.375rem;
      background: transparent;
      border: none;
      cursor: pointer;
      color: #9ca3af;
      transition: color 0.15s, background 0.15s;
      white-space: nowrap;
      overflow: hidden;
    }

    .logout-btn:hover {
      color: #db2777;
      background: linear-gradient(90deg, #fff0f7, transparent);
    }

    .logout-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 34px;
      height: 34px;
      border-radius: 10px;
      background: #faf8ff;
      border: 1.5px solid #f0eafa;
      flex-shrink: 0;
      transition: background 0.15s, border-color 0.15s, color 0.15s;
    }

    .logout-btn:hover .logout-icon {
      background: #fff0f7;
      border-color: #fbcfe8;
      color: #db2777;
    }

    .logout-label {
      font-size: 0.875rem;
      font-weight: 500;
      letter-spacing: -0.01em;
    }
  `, "",{"version":3,"sources":["webpack://./libs/ui/src/lib/components/sections/zikata-sidebar/zikata-sidebar.component.ts"],"names":[],"mappings":";IACI;MACE,8CAA8C;IAChD;;IAEA,iCAAiC;IACjC;MACE,eAAe;MACf,QAAQ;MACR,kCAAkC;MAClC,kCAA0B;cAA1B,0BAA0B;MAC1B,aAAa;MACb,2BAA2B;IAC7B;;IAEA;MACE,OAAO,UAAU,EAAE;MACnB,OAAO,UAAU,EAAE;IACrB;;IAEA,wBAAwB;IACxB;MACE,aAAa;MACb,sBAAsB;MACtB,YAAY;MACZ,YAAY;MACZ,mBAAmB;MACnB,iCAAiC;MACjC,+CAA+C;MAC/C,gBAAgB;MAChB,kBAAkB;MAClB,aAAa;MACb,cAAc;IAChB;;IAEA,iBAAiB;IACjB;MACE,eAAe;MACf,MAAM;MACN,OAAO;MACP,aAAa;MACb,YAAY;MACZ,4BAA4B;MAC5B,uDAAuD;MACvD,aAAa;IACf;;IAEA;MACE,wBAAwB;MACxB,+CAA+C;IACjD;;IAEA,sBAAsB;IACtB;MACE,aAAa;MACb,mBAAmB;MACnB,sBAAsB;MACtB,gBAAgB;MAChB,cAAc;IAChB;;IAEA;MACE,aAAa;MACb,mBAAmB;IACrB;;IAEA;MACE,YAAY;MACZ,YAAY;MACZ,mBAAmB;MACnB,cAAc;IAChB;;IAEA,kBAAkB;IAClB;MACE,WAAW;MACX,sFAAsF;MACtF,cAAc;MACd,kBAAkB;IACpB;;IAEA,oBAAoB;IACpB;MACE,OAAO;MACP,gBAAgB;MAChB,kBAAkB;MAClB,mBAAmB;MACnB,qBAAqB;IACvB;;IAEA;MACE,aAAa;IACf;;IAEA,0BAA0B;IAC1B;MACE,cAAc;MACd,uBAAuB;IACzB;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,YAAY;MACZ,WAAW;MACX,qBAAqB;MACrB,oBAAoB;MACpB,uBAAuB;MACvB,YAAY;MACZ,eAAe;MACf,cAAc;MACd,yCAAyC;MACzC,mBAAmB;MACnB,gBAAgB;IAClB;;IAEA;MACE,cAAc;MACd,wDAAwD;IAC1D;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,WAAW;MACX,YAAY;MACZ,mBAAmB;MACnB,mBAAmB;MACnB,2BAA2B;MAC3B,cAAc;MACd,6DAA6D;IAC/D;;IAEA;MACE,mBAAmB;MACnB,qBAAqB;MACrB,cAAc;IAChB;;IAEA;MACE,mBAAmB;MACnB,gBAAgB;MAChB,uBAAuB;IACzB","sourcesContent":["\n    :host {\n      font-family: 'DM Sans', 'Segoe UI', sans-serif;\n    }\n\n    /* ── Backdrop (mobile only) ── */\n    .sidebar-backdrop {\n      position: fixed;\n      inset: 0;\n      background: rgba(60, 0, 100, 0.18);\n      backdrop-filter: blur(3px);\n      z-index: 1029;\n      animation: fadeIn 0.2s ease;\n    }\n\n    @keyframes fadeIn {\n      from { opacity: 0; }\n      to   { opacity: 1; }\n    }\n\n    /* ── Sidebar shell ── */\n    .sidebar {\n      display: flex;\n      flex-direction: column;\n      width: 240px;\n      height: 100%;\n      background: #ffffff;\n      border-right: 1.5px solid #f0eafa;\n      box-shadow: 2px 0 16px rgba(109, 40, 217, 0.06);\n      overflow: hidden;\n      position: relative;\n      z-index: 1030;\n      flex-shrink: 0;\n    }\n\n    /* ── Mobile ── */\n    .sidebar--mobile {\n      position: fixed;\n      top: 0;\n      left: 0;\n      height: 100vh;\n      width: 260px;\n      transform: translateX(-100%);\n      transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n      z-index: 1030;\n    }\n\n    .sidebar--mobile-open {\n      transform: translateX(0);\n      box-shadow: 6px 0 32px rgba(109, 40, 217, 0.12);\n    }\n\n    /* ── Top section ── */\n    .sidebar-top {\n      display: flex;\n      align-items: center;\n      padding: 1.125rem 1rem;\n      min-height: 64px;\n      flex-shrink: 0;\n    }\n\n    .sidebar-logo {\n      display: flex;\n      align-items: center;\n    }\n\n    .sidebar-logo-img {\n      width: 120px;\n      height: auto;\n      object-fit: contain;\n      display: block;\n    }\n\n    /* ── Divider ── */\n    .sidebar-divider {\n      height: 1px;\n      background: linear-gradient(90deg, transparent, #f0eafa 30%, #f9d5ea 70%, transparent);\n      flex-shrink: 0;\n      margin: 0 0.875rem;\n    }\n\n    /* ── Menu area ── */\n    .sidebar-menu-wrap {\n      flex: 1;\n      overflow-y: auto;\n      overflow-x: hidden;\n      padding: 0.625rem 0;\n      scrollbar-width: none;\n    }\n\n    .sidebar-menu-wrap::-webkit-scrollbar {\n      display: none;\n    }\n\n    /* ── Bottom / logout ── */\n    .sidebar-bottom {\n      flex-shrink: 0;\n      padding-bottom: 0.75rem;\n    }\n\n    .logout-btn {\n      display: flex;\n      align-items: center;\n      gap: 0.75rem;\n      width: 100%;\n      padding: 0.65rem 1rem;\n      margin-top: 0.375rem;\n      background: transparent;\n      border: none;\n      cursor: pointer;\n      color: #9ca3af;\n      transition: color 0.15s, background 0.15s;\n      white-space: nowrap;\n      overflow: hidden;\n    }\n\n    .logout-btn:hover {\n      color: #db2777;\n      background: linear-gradient(90deg, #fff0f7, transparent);\n    }\n\n    .logout-icon {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 34px;\n      height: 34px;\n      border-radius: 10px;\n      background: #faf8ff;\n      border: 1.5px solid #f0eafa;\n      flex-shrink: 0;\n      transition: background 0.15s, border-color 0.15s, color 0.15s;\n    }\n\n    .logout-btn:hover .logout-icon {\n      background: #fff0f7;\n      border-color: #fbcfe8;\n      color: #db2777;\n    }\n\n    .logout-label {\n      font-size: 0.875rem;\n      font-weight: 500;\n      letter-spacing: -0.01em;\n    }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
